<template>
  <div class="member">
    <div class="main__wrapper">
      <div class="page__left">
        <div class="member__title">{{ pageData.member.title }}</div>
        <div class="member__desc">{{ pageData.member.description }}</div>
      </div>
      <div v-if="series" class="page__right">
        <TestvMemberCard class="benefit__item" :expiredAt="pageData.expiry"/>
        <TestvBenefitCard class="benefit__item" :benefit="group"/>
        <TestvBenefitCard class="benefit__item" :benefit="merchandise"/>
        <div v-if="notes" v-html="notes" class="notes"></div>
      </div>
    </div>
    <footer>
      <TestvFooter class="comp__TestvFooter"/>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TestvMemberCard from '@/components/TestvMemberCard/index.vue'
import TestvBenefitCard from '@/components/TestvBenefitCard/index.vue'
import TestvFooter from '@/components/TestvFooter/index.vue'
import ScrollMagic from 'scrollmagic'

export default {
  name: 'Member',

  components: {
    TestvMemberCard,
    TestvBenefitCard,
    TestvFooter
  },

  data () {
    return {
      controller: null
    }
  },

  computed: {
    ...mapState(['series', 'pageData']),
    group () {
      if (!this.pageData) return null
      return this.pageData.benefits.group
    },
    merchandise () {
      if (!this.pageData) return null
      return this.pageData.benefits.merchandise
    },
    notes () {
      if (!this.pageData) return ''
      return this.pageData.benefits.notes
    }
  },

  methods: {
    bindAnimations () {
      const el = document.querySelector('.page__right')
      new ScrollMagic.Scene({
        triggerElement: el,
        offset: 0,
        triggerHook: 1,
        reverse: false
      })
      .setClassToggle(el, 'slide')
      .addTo(this.controller)
    }
  },

  mounted () {
    this.controller = new ScrollMagic.Controller()
    this.bindAnimations()
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.member {
  padding: 24px 0;
  @media (min-width: $screen-md) {
    padding: 32px 0;
  }
}
.main__wrapper {
  padding: 0 16px;
  @media (min-width: $screen-md) {
    display: flex;
    column-gap: 90px;
    justify-content: center;
  }
  @media (min-width: $screen-lg) {
    max-width: 996px;
    margin: auto;
    justify-content: space-between;
  }
  .member__title {
    font-size: 56px;
    font-weight: 600;
    margin-bottom: 8px;
    white-space: pre-wrap;
    @media (min-width: $screen-md) {
      font-size: 64px;
    }
    @media (min-width: $screen-lg) {
      font-size: 80px;
    }
  }
  .member__desc {
    font-size: 15px;
    color: var(--dark-bwb-5);
    white-space: pre-wrap;
  }

  .page__left {
    @media (min-width: $screen-md) {
      width: 128px;
    }
    @media (min-width: $screen-lg) {
      width: 160px;
    }
  }
  .page__right {
    .benefit__item {
      margin: 32px 0;
    }
    .notes {
      color: var(--dark-bwb-8);
      font-size: 15px;
      margin: 10px 0;
      >>> a {
        color: var(--yellow-testv)!important;
      }
    }
    @media (min-width: $screen-md) {
      width: 486px;
      .benefit__item:first-child {
        margin-top: 0;
      }
    }
  }
}
.comp__TestvFooter {
  padding: 0 16px;
  >>> .testv__footer__left {
    display: none;
  }
  @media (min-width: $screen-md) {
    column-gap: 90px;
    justify-content: center;
    >>> .testv__footer__left {
      display: block;
      width: 128px;
    }
    >>> .testv__footer {
      width: 486px;
      flex: none;
    }
  }
  @media (min-width: $screen-md) {
    max-width: 996px;
    margin: auto;
    justify-content: space-between;
    >>> .testv__footer__left {
      width: 160px;
    }
  }
}
.page__right {
  .benefit__item {
    opacity: 0;
    transform: translateY(20px);
  }
  &.slide {
    .benefit__item {
      opacity: 1;
      transform: translateY(0px);
      transition: all 1s ease;
      &:nth-child(1) {
        transition-delay: 0.2s;
      }
      &:nth-child(2) {
        transition-delay: 0.4s;
      }
      &:nth-child(3) {
        transition-delay: 0.8s;
      }
    }
  }
}
</style>
